import type React from "react";
import { ReactComponent as Svg } from "./assets/open.svg";
import * as styles from "./Icon.module.scss";

type OpenProps = React.SVGProps<SVGSVGElement>;

export const Open = ({ className, ...props }: OpenProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
